import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";

const HeroSection = () => {
  const words = [" Rohan's Tax Services"];

  return (
    <Box
      sx={{
        position: "relative",
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "translate(-50%, -50%)",
          zIndex: -1, // Puts the video behind content
        }}
      >
        <source
          src="https://res.cloudinary.com/do9tqu9sb/video/upload/f_auto:video,q_auto/v1/Logo/kbkkdh1k8bpetncamyoc"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          textAlign: "center",
          paddingX: 2,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="z-20 text-white text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl"
        >
          <div className="flex md:flex-row flex-col items-center  text-xs sm:text-lg md:text-3xl lg:text-3xl xl:text-4xl py-3">
            {/* Static part, stays steady */}
            <div className="flex-shrink-0 font-semibold md:mb-0 mb-4 leading-none md:leading-normal lg:leading-relaxed">
              {"Simplify Your Taxes with "}
              <span>&nbsp;</span>
            </div>

            {/* Typewriter part */}
            <div className="text-white text-2xl md:text-3xl md:leading-normal lg:leading-relaxed font-bold">
              <Typewriter
                options={{
                  strings: words,
                  autoStart: true,
                  loop: true,
                  delay: 75,
                  deleteSpeed: 50,
                }}
              />
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="z-20"
        >
          <Typography
            variant="h6"
            sx={{
              marginBottom: 3,
              color: "white",
              fontSize: { xs: "0.8rem", sm: "1.5rem", md: "1.75rem" },
            }}
          >
            Strive For Excellence, Success Will Follow .
          </Typography>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="grid grid-cols-2 sm:grid-cols-2 gap-4 justify-items-center items-center"
          >
            <a href="#services">
              <button className="md:w-48 w-32  px-4 py-2 rounded-full border border-neutral-600 text-white bg-[#151C62] hover:bg-gray-100 hover:text-[#151C62] transition duration-200">
                Our Services
              </button>
            </a>

            <a href="#contact">
              <button className="md:w-48 w-32 relative inline-flex h-12 overflow-hidden rounded-full p-[1px] focus:outline-none focus:ring-2 focus:ring-black-400 focus:ring-offset-2 focus:ring-offset-black-400">
                <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#E2CBFF_0%,#393BB2_50%,#E2CBFF_100%)]" />
                <span className="inline-flex h-full w-full cursor-pointer items-center justify-center rounded-full bg-slate-950 px-5 py-5 text-sm font-medium text-white backdrop-blur-3xl border border-white hover:text-[#151C62] hover:bg-white">
                  Let's Talk
                </span>
              </button>
            </a>
          </motion.div>
        </motion.div>
      </Box>
    </Box>
  );
};

export default HeroSection;
